import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import Link from '../../routing/components/Link';
import {annotationIndexRoute, structureIndexRoute, articleIndexRoute, annotationsRoute} from '../../../constants/public-routes';
import {getIdFromRelation} from '../../app/selectors';
import Result from './Result';

class SearchResult extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    let {item, intl} = this.props;
    let {locale} = intl;
    let body = item.attributes.preview.body ?
      <div dangerouslySetInnerHTML={{__html: '<p>' + item.attributes.preview.body.replace(/\n/g, "</p><p>\n") + '</p>'}}/> :
      null;
    let adds = [];
    let urls = [];
    let mainUrl = null;
    let key = item.id;
    let header = [];
    let label = item.attributes.preview.label ? <span key="label" dangerouslySetInnerHTML={{__html: item.attributes.preview.label}}/> : item.attributes.label;
    switch (item.attributes.model_type) {
      case 'structure':
        mainUrl = structureIndexRoute(locale, item.id);
        header.push(<Link url={mainUrl}>{label}</Link>);
        urls.push({
          url: mainUrl,
          label: (<FormattedMessage id={item.attributes.model_type}/>)
        });
        break;
      case 'article':
        mainUrl = articleIndexRoute(locale, getIdFromRelation(item, 'structure'), item.id);
        header.push(<span key="label" className="large"><Link url={mainUrl}>{label}</Link></span>);
        urls.push({
          url: mainUrl,
          label: (<FormattedMessage id={item.attributes.model_type}/>)
        });
        break;
      case 'annotation':
        mainUrl = annotationIndexRoute(locale, getIdFromRelation(item, 'structure'), getIdFromRelation(item, 'article'), getIdFromRelation(item, 'element'), item.id);
        header.push(<span key="label"><Link url={mainUrl}>{label}</Link></span>);
        urls.push({
          url: mainUrl,
          label: (<FormattedMessage id={item.attributes.concept_type}/>)
        });
        break;
    }
    header.push(<br key="label-br"/>);
    header.push(<span key="label-meta" className="small"><FormattedMessage
      id={item.attributes.model_type === 'annotation' ? item.attributes.concept_type : item.attributes.model_type}/>,&nbsp;<FormattedMessage
      id={item.attributes.language}/>{item.attributes.model_type === 'article' ? <span>,&nbsp;<FormattedMessage
      id="from"/>: {item.attributes.label_structure}</span> : null}</span>);

    if (item.attributes.preview.tag) {
      adds.push(<div key="tag" className="search-extra-div">
        <hr/>
        <p className="search-extra"><span className="search-label"><FormattedMessage id="foundTag"/></span><span
          dangerouslySetInnerHTML={{__html: item.attributes.preview.tag}}/></p></div>);
    }
    if (item.attributes.preview.category) {
      adds.push(<div key="category" className="search-extra-div">
        <hr/>
        <p className="search-extra"><span className="search-label"><FormattedMessage id="foundCategory"/></span>
          <span dangerouslySetInnerHTML={{__html: item.attributes.preview.category}}/>
          <span className="small">&nbsp;&mdash;&nbsp;
            <Link
              url={annotationsRoute(locale, getIdFromRelation(item, 'structure'), getIdFromRelation(item, 'article'), getIdFromRelation(item, 'element'), item.id)}>
            <FormattedMessage id="annotations"/>
          </Link>&nbsp;&mdash;&nbsp;
            <Link
              url={articleIndexRoute(locale, getIdFromRelation(item, 'structure'), getIdFromRelation(item, 'article'))}>
            <FormattedMessage id="article"/>
          </Link>
          </span>
        </p></div>);
    }
    return (<Result key={key} header={header} body={body} adds={adds} urls={urls}/>);
  }
}

SearchResult.propTypes = {
  item: React.PropTypes.object,
  intl: React.PropTypes.object
};

function mapStateToProps(state) {

  const {intl, searchresults} = state;
  const date = searchresults.query.filters.date;
  return {
    intl,
    date
  };
}

export default connect(mapStateToProps)(SearchResult);



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/SearchResult.js
 **/